import React from "react";
import { Tooltip } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  entityType: props => ({
    padding: "1px 3px 2px 3px",
    position: "relative",
    zIndex: 1,
    color: "#000",
    whiteSpace: "nowrap",
    "&:after": {
      content: '""',
      backgroundColor: props.color,
      position: "absolute",
      height: "100%",
      width: "100%",
      top: 0,
      left: 0,
      borderRadius: 4,
      zIndex: -1,
      opacity: 0.15
    }
  })
});

const Entity = props => {
  function hashCode(str) {
    var hash = 0;
    for (var i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    return hash;
  }
  function intToRGB(i) {
    var c = (i & 0x00ffffff).toString(16).toUpperCase();
    return "00000".substring(0, 6 - c.length) + c;
  }
  const classes = useStyles({ color: "#" + intToRGB(hashCode(props.entity)) });
  return (
    <Tooltip arrow title={props.entity}>
      <span className={`${classes.entityType} entity`}>{props.text}</span>
    </Tooltip>
  );
};

export default Entity;
